export class ProtectionPricingCard {
	id: number;
	productId: number;
	protectionLevelId: number;
	superhogUserId?: string | null;
	currencyId: number;
	pricingCardTypeId: number;
	approvedAmount: number;
	flaggedAmount: number;
	rejectedAmount: number;
	cancelledAmount: number;
	startDate: Date | string;
	endDate?: Date | string | null;
	createdDate: Date | string;
	updatedDate?: Date | string | null;
}
